import axios from "axios";
import { BASE_URL } from "../../constants";
import {
    CART_EMPTY,
    MY_ORDER_FAIL,
    MY_ORDER_REQUEST,
    MY_ORDER_SUCCESS,
    ORDER_CREATE_FAIL,
    ORDER_CREATE_REQUEST,
    ORDER_CREATE_SUCCESS,
    ORDER_DETAILS_FAIL,
    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_PAY_FAIL,
    ORDER_PAY_REQUEST,
    ORDER_PAY_SUCCESS,
} from "../Constants/orderConstants";

export const createOrderActions = (order) => async (dispatch, getState) => {
    dispatch({ type: ORDER_CREATE_REQUEST, payload: order });
    try {
        const {
            singInInfo: { userInfo },
        } = getState();
        const { data } = await axios.post(`${BASE_URL}/api/orders`, order, {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        });
        dispatch({ type: ORDER_CREATE_SUCCESS, payload: data.order });
        dispatch({ type: CART_EMPTY });
        localStorage.removeItem("cartItems");
    } catch (error) {
        dispatch({
            type: ORDER_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const detailsOrder = (orderId) => async (dispatch, getState) => {
    dispatch({ type: ORDER_DETAILS_REQUEST, payload: orderId });
    const {
        singInInfo: { userInfo },
    } = getState();
    try {
        const { data } = await axios.get(`${BASE_URL}/api/orders/${orderId}`, {
            headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;
        dispatch({ type: ORDER_DETAILS_FAIL, payload: message });
    }
};

export const payOrder =
    (order, paymentResult) => async (dispatch, getState) => {
        dispatch({
            type: ORDER_PAY_REQUEST,
            payload: { order, paymentResult },
        });
        const {
            singInInfo: { userInfo },
        } = getState();

        try {
            const { data } = axios.put(
                `${BASE_URL}/api/orders/${order._id}/pay`,
                paymentResult,
                {
                    headers: { Authorization: `Bearer ${userInfo.token}` },
                }
            );
            dispatch({ type: ORDER_PAY_SUCCESS, payload: data });
        } catch (error) {
            const message =
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message;
            dispatch({ type: ORDER_PAY_FAIL, payload: message });
        }
    };

export const listOrderMine = () => async (dispatch, getState) => {
    dispatch({ type: MY_ORDER_REQUEST });
    const {
        singInInfo: { userInfo },
    } = getState();
    try {
        const { data } = await axios.get(`${BASE_URL}/api/orders/mine`, {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        });
        dispatch({ type: MY_ORDER_SUCCESS, payload: data });
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;
        dispatch({ type: MY_ORDER_FAIL, payload: message });
    }
};
